<template>
  <component :is="tag" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { getExtension } from '@/utils/file-helper'

export default {
  name: 'BrbMedia',
  inheritAttrs: false,
  components: {
    BrbThumbnail: () => import('./BrbThumbnail.vue'),
    BrbVideo: () => import('./BrbVideo.vue')
  },
  computed: {
    tag() {
      if (this.isVideo) return 'brb-video'
      return 'brb-thumbnail'
    },
    isVideo() {
      const extensions = new Set(['mp4', 'webm', 'wmv', 'flv', 'avi', 'mov'])
      return extensions.has(getExtension(this.$attrs.src))
    }
  }
}
</script>
